'use strict';

import 'angular';

export default function() {
	'ngInject';

	return {
		scope: {
			moduleChoices: '<',
			problemTypeChoices: '<',
		},
		link: {
			pre: preLink,
		},
		controller: controller,
		controllerAs: '$classifyCtrl',
		transclude: true,
	}

	function preLink(scope, element, attrs, ctrl, transclude) {
		transclude(scope, function(clone, scope) {
			element.append(clone);
		});
	}

	function controller($http, $scope, toastr) {
		'ngInject';

		const vm = this;
		vm.unclassifiedCount = -1;
		vm.lockedIncident = {};
		vm.moduleChoices = [];
		vm.problemTypeChoices = [];
		vm.autolockNext = true;

		// Build module choices
		angular.forEach($scope.moduleChoices, (arr) => {
			vm.moduleChoices.push({
				label: arr[0],
				displayLabel: arr[1],
			});
		});

		// Build problem type choices
		angular.forEach($scope.problemTypeChoices, (arr) => {
			vm.problemTypeChoices.push({
				label: arr[0],
				displayLabel: arr[1],
				description: arr[2],
			});
		});

		function _processLockedData(data) {
			vm.lockedIncident = data;
			vm.unclassifiedCount = data.unclassified_count;

			function _scoredChoices(choices, predictions) {
				let _scores = {};
				let _total_score = 0;
				angular.forEach(predictions, (value) => {
					_scores[value[0]] = value[1];
					_total_score += value[1];
				});
				const _average_score = _total_score/predictions.length;
				angular.forEach(choices, (choice) => {
					choice.score = _scores[choice.label] || 0;
					choice.isTopScore = choice.score >= _average_score;
				});
				let retval = angular.copy(choices);
				retval.sort((a, b) => {
					// The choices are already sorted by how common they are for the
					// entity, so we fall back to this sorting for any scores below a
					// certain threshold.
					return Math.max(b.score, 0.005) - Math.max(a.score, 0.005);
				});

				// Set a cutoff point
				for (let i = 0; i < retval.length; i++) {
					if (retval[i].score < _average_score) {
						if (i > 0) retval[i-1].isCutoff = true;
						break;
					}
				}
				return retval;
			}

			try {
				vm.lockedModuleChoices = _scoredChoices(
					vm.moduleChoices, data.predictions.module_predictions_v1
				);
			} catch(e) {
				vm.lockedModuleChoices = vm.moduleChoices;
			}

			try {
				vm.lockedProblemTypeChoices = _scoredChoices(
					vm.problemTypeChoices, data.predictions.problem_type_predictions_v1
				);
			} catch(e) {
				vm.lockedProblemTypeChoices = vm.problemTypeChoices;
			}
		}

		vm.lockNext = function() {
			if (vm.loading) return;
			vm.loading = true;
			$http
				.post('/api/incidents/ml/classify/v1/lock_next/', {})
				.then((response) => {
					vm.state = response.data.result;
					switch (response.data.result) {
						case 'LOCKED':
							_processLockedData(response.data);
							break;
						case 'NONE':
							vm.unclassifiedCount = 0;
						default:
							console.log(response);
					}
				}, (error) => {
					console.error(error);
				})
				.finally(() => {
					vm.loading = false;
				});
		}
		vm.lockNext();

		vm.classify = function(incident, module, problemType) {
			const data = {
				incident: incident,
				module: module,
				problem_type: problemType,
			};
			$http.post('/api/incidents/ml/classify/v1/manually_classify/', data).then(
				(response) => {
					console.log('Classified', response);
					vm.lockedIncident.saved = true;
					if (vm.autolockNext) {
						vm.lockNext();
					}
				},
				(error) => {
					console.error(error);
					vm.lockedIncident.saved = false;
				}
			);
		}

		vm.skip = function(incident, reason) {
			const data = { incident, reason };
			$http.post('/api/incidents/ml/classify/v1/skip_manual/', data).then(
				(response) => {
					console.log(response);
					vm.lockedIncident.skipped = true;
					if (vm.autolockNext) {
						vm.lockNext();
					}
				},
				(error) => {
					console.error(error);
					vm.lockedIncident.skipped = false;
				}
			);
		}

	}
}
